
export default {
  name: 'PoliticaCookie',
  data() {
    return {
      footer: true,
    }
  },
  mounted() {
    const cookie = this.$cookie.get('cookie-consent')
    const cookieRejected = sessionStorage.getItem('cookie-consent')
    if (cookie || cookieRejected) {
      this.footer = false
    }
  },
  methods: {
    rejeitar() {
      this.footer = false
      sessionStorage.setItem('cookie-consent', 'cookie rejected')
    },
    aceitar() {
      this.footer = false
      this.$cookie.set('cookie-consent', 'cookie accepted', 15)
    },
  },
}
